<!--
 * @Description: 
 * @Author: zml
 * @Date: 2023-03-21 11:49:51
 * @LastEditors: zml
 * @LastEditTime: 2025-03-19 15:35:08
-->
<template>
  <el-dialog @close="close" :visible="visible" :close-on-click-modal="false" width="1300px" center append-to-body>
    <div class="login-title">
      <div class="title">{{ $hs('综合查询', 'Comprehensive Query', 'Para consultas integradas')}}</div>
    </div>
    <div class="form-box">
      <el-form ref="form" :model="form" label-width="140px" label-position="right">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$hs('关键词:', 'Keywords:','Palabra clave')">
              <el-input v-model="form.like" :placeholder="$t('PleaseKeywords')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$hs('公司编号:', 'Company Number:','Número de empresa:')">
              <el-input v-model="form.co_Nu" :placeholder="$t('ArtContent')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-col :span="12">
                <el-form-item :label="$hs('包装方式:', 'Package:','Forma de embalaje:')">
                  <el-input v-model="form.packMethod" :placeholder="$t('PackingSelect')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$hs('英文包装','EnglishPacking:','Paquete en inglés:')">
                  <el-input v-model="form.en_Pa" :placeholder="$hs('请输入英文包装','English packaging','')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item :label="$hs('外箱装量:','Outer QTY:','Cantidad de carga en cartón externo')">
              <el-input v-model="form.ou_Lo" :placeholder="$hs('请输入外箱装量','Outer box capacity','')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$hs('内盒个数:','Inner Boxes:','Número de cajas internas')">
              <el-input v-model="form.in_En" :placeholder="$hs('请输入内盒个数','Number of inner boxes','')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$hs('外箱体积:','CBM:','Volumen del cartón exterior')">
              <el-input v-model="form.bulk_Stere" :placeholder="$hs('请输入外箱体积','CBM','')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$hs('外箱材积:','CUFT:','Volumen del cartón exterior')">
              <el-input v-model="form.bulk_Feet" :placeholder="$hs('请输入外箱材积','CUFT','')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-row>
              <el-col :span="12">
                <el-form-item :label="$hs('外箱毛重:','G.W:','Peso bruto')">
                  <el-input v-model="form.gr_We" :placeholder="$hs('请输入外箱毛重','Outer box gross weight','')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$hs('外箱净重:','N.W:','Peso neto')">
                  <el-input v-model="form.ne_We" :placeholder="$hs('请输入外箱净重','Net weight of the outer box','')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$hs('包装规格:','Package Size:','Especificación del paquete')">
              <div style="display: flex;">
                <el-input v-model="form.in_Le" :placeholder="$hs('长区间(cm)','Length(cm)','Intervalo largo (cm)')"></el-input>
                <span style="margin: 0 10px;font-weight: bold;">-</span>
                <el-input v-model="form.in_Wi" :placeholder="$hs('宽区间(cm)','Width(cm)','Amplio intervalo (cm)')"></el-input>
                <span style="margin: 0 10px;font-weight: bold;">-</span>
                <el-input v-model="form.in_Hi" :placeholder="$hs('高区间(cm)','Height(cm)','Intervalo alto (cm)')"></el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$hs('产品规格:','Product Size:','Especificaciones del producto')">
              <div style="display: flex;">
                <el-input v-model="form.pr_Le" :placeholder="$hs('长区间(cm)','Length(cm)','Intervalo largo (cm)')"></el-input>
                <span style="margin: 0 10px;font-weight: bold;">-</span>
                <el-input v-model="form.pr_Wi" :placeholder="$hs('宽区间(cm)','Width(cm)','Amplio intervalo (cm)')"></el-input>
                <span style="margin: 0 10px;font-weight: bold;">-</span>
                <el-input v-model="form.pr_Hi" :placeholder="$hs('高区间(cm)','Height(cm)','Amplio intervalo (cm)')"></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$hs('产品认证:','Certificate:','Certificación de reconocimiento')">
              <el-input v-model="form.attestation" :placeholder="$hs('证书','Certificate:','El certificado')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$hs('外箱规格:','Carton Size:','Especificación del cartón exterior')">
              <div style="display: flex;">
                <el-input v-model="form.ou_Le" :placeholder="$hs('长区间(cm)','Length(cm)','Intervalo largo (cm)')"></el-input>
                <span style="margin: 0 10px;font-weight: bold;">-</span>
                <el-input v-model="form.ou_Wi" :placeholder="$hs('宽区间(cm)','Width(cm)','Amplio intervalo (cm)')"></el-input>
                <span style="margin: 0 10px;font-weight: bold;">-</span>
                <el-input v-model="form.ou_Hi" :placeholder="$hs('高区间(cm)','Height(cm)','Intervalo alto (cm)')"></el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="operation">
        <div class="reset" @click="reset">{{$t('reset')}}</div>
        <div class="serch" @click="advancedSearchFun">{{$t('search')}}</div>
      </div>
    </div>
  </el-dialog>
</template>
<script>

import { bus } from '../../utils/bus';

export default {
  name: 'loginModal',
  components: {
  },
  data() {
    return {
      visible: false,
      codeData: {},
      form: {
        like: '',
        fa_No: '',
        packMethod: '',
        en_Pa: "",
        ou_Lo: "",
        in_En: "",
        bulk_Stere: "",
        bulk_Feet: "",
        gr_We: "",
        ne_We: "",
        in_Le: "",
        in_Wi: "",
        in_Hi: "",
        pr_Le: "",
        pr_Wi: "",
        pr_Hi: "",
        attestation: "",
        ou_Le: "",
        ou_Wi: "",
        ou_Hi: "",
      },
      rules: {}
    }
  },
  methods: {
    open() {
      this.visible = true
    },
    close() {
      this.visible = false
      this.$refs.form.resetFields()
    },
    resetPass() {
      this.$refs.resetPassModel.open()
    },
    reset() {
      this.form = {
        like: '',
        fa_No: '',
        packMethod: '',
        en_Pa: "",
        ou_Lo: "",
        in_En: "",
        bulk_Stere: "",
        bulk_Feet: "",
        gr_We: "",
        ne_We: "",
        in_Le: "",
        in_Wi: "",
        in_Hi: "",
        pr_Le: "",
        pr_Wi: "",
        pr_Hi: "",
        attestation: "",
        ou_Le: "",
        ou_Wi: "",
        ou_Hi: "",
      }
    },
    // 构建复杂查询条件
    advancedSearchFun() {
      const conditionals = []
      let formData = this.form
      for (const key in formData) {
        if (formData[key]) {
          if (key === 'like') {
            conditionals.push({
              conditionalType: 1,
              fieldName: 'co_Nu',
              fieldValue: formData[key],
              key: 0
            })
            conditionals.push({
              conditionalType: 1,
              fieldName: 'pr_Na',
              fieldValue: formData[key],
              key: 0
            })
            conditionals.push({
              conditionalType: 1,
              fieldName: 'cl_Na',
              fieldValue: formData[key],
              key: 0
            })
            conditionals.push({
              conditionalType: 1,
              fieldName: 'pr_En_Na',
              fieldValue: formData[key],
              key: 0
            })
            conditionals.push({
              conditionalType: 1,
              fieldName: 'basicThreeLanguage',
              fieldValue: formData[key],
              key: 0
            })
          } else if (key === 'co_Nu') {
            conditionals.push({
              conditionalType: 6,
              fieldName: key,
              fieldValue: formData[key],
              key: 0
            })
          } else {
            conditionals.push({
              conditionalType: 1,
              fieldName: key,
              fieldValue: formData[key],
              key: 0
            })
          }
        }
      }
      this.visible = false
      this.reset();
      this.$bus.$emit('QueryData', conditionals);
      this.$router.push({
        name: 'product', params: {
          conditionals: conditionals
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.operation {
  padding: 0 40px 30px;
  font-size: 14px;
  color: #222222;
  display: flex;
  justify-content: center;

  & > div {
    width: 150px;
    height: 42px;
    line-height: 42px;
    font-size: 16px;
    text-align: center;
    cursor: pointer;
  }

  .reset {
    background: #f5f5f9;
    border: 1px solid #d6d6d6;
    color: #b2b2b2;
    border-radius: 4px;
  }
  .serch {
    background: #490d59;
    border: 1px solid #490d59;
    color: #ffffff;
    margin-left: 20px;
    border-radius: 4px;
  }
}

:deep(.el-dialog__header) {
  text-align: left;
  padding: 0px;
  .el-dialog__headerbtn {
    z-index: 99;
  }
}
:deep(.el-dialog__body) {
  padding: 0 !important;
  .login-title {
    height: 64px;
    border-bottom: 1px solid #eee;

    .title {
      height: 64px;
      line-height: 64px;
      text-align: left;
      font-size: 15px;
      font-weight: bold;
      margin-left: 10px;
      color: #222222;
    }
    .msg {
      text-align: center;
      font-size: 14px;
      color: #999999;
    }
  }

  .form-box {
    padding: 20px;
  }
}
:deep .el-form {
  padding: 0 40px 0 0;
  .valide-code {
    .el-input {
      margin: 0 10px 0 0;
    }
    .el-form-item__content {
      display: flex;
    }
  }
}

.dialog-footer {
  display: flex;
  padding: 20px 40px 0;
  box-sizing: border-box;
  .btn {
    flex: 1;
    margin-bottom: 10px;
    background-color: #00923f;
    border-color: #00923f;
  }
}

:deep(.el-form-item__error) {
  display: none;
}
:deep(.el-form-item) {
  display: flex;
}
:deep(.el-form-item__content) {
  flex: 1;
  margin: 0 !important;
}
:deep(.el-form-item__label) {
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*禁止换行*/
  text-overflow: ellipsis; /*省略号*/
  width: 140px !important;
}
</style>